import { render, staticRenderFns } from "./PermissionSelectbox.vue?vue&type=template&id=813c7c76"
import script from "./PermissionSelectbox.vue?vue&type=script&lang=js"
export * from "./PermissionSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports